import dayjs from "dayjs";
import { todayInSydney } from "./clock";
import { AttributeFilterOption, SearchAppQuerySortDirection, SearchAppQuerySortField } from "./interfaces";
import { CUSTOM_ATTRIBUTE_FILTER_OPTION_LABELS } from "./attributeFilterConstants";
import { SortingBy } from "../client/components/SortingDropdown";

export function centsToDollars(cents: any, decimalPlaces: number = 0): string {
  if (typeof cents !== "number") {
    return "NaN";
  }
  return (cents / 100).toFixed(decimalPlaces);
}

export function noop() {}

export function isWeekend(date: Date) {
  let mDate = dayjs(date);
  return mDate.day() === 0 || mDate.day() === 6;
}

export function isBeforeToday(date: Date) {
  const today = todayInSydney();
  return dayjs(date).isBefore(today, "day");
}

export function toIsoDate(day: Date | null) {
  if (day === null) {
    return "";
  }

  return dayjs(day).format("YYYY-MM-DD");
}

export function isTouchDevice() {
  const documentWidth = document.body.getBoundingClientRect().width;
  return document.querySelector("html.no-touch") === null || documentWidth < 500; // width check for easy testing on desktop
}

export function coreLibraryInitialised() {
  // @ts-ignore
  return typeof GlamCornerCore !== "undefined";
}

// In some tests coreLibraryInitialised() returns true
export function isGcSessionReady() {
  // @ts-ignore
  return coreLibraryInitialised() && GlamCornerCore.gcSession;
}

export function alwaysTrue() {
  return true;
}

export function isNodeEnvironment(): boolean {
  return typeof process !== "undefined" && !!process.release && process.release.name === "node";
}

export const compareAttributeFilterOptions = (
  { value: opt1Value }: AttributeFilterOption,
  { value: opt2Value }: AttributeFilterOption
) => {
  if (opt1Value < opt2Value) {
    return -1;
  }
  if (opt1Value > opt2Value) {
    return 1;
  }
  return 0;
};

export const getKeyByValue = (obj: object, value: any) => Object.keys(obj).find(key => obj[key] === value);

export function attributeFilterOptionByValue(value: string): AttributeFilterOption {
  const label = CUSTOM_ATTRIBUTE_FILTER_OPTION_LABELS[value] || value;

  return {
    label,
    value
  };
}

export const retranslateAttributeOptionFilter = (label: string) => {
  return getKeyByValue(CUSTOM_ATTRIBUTE_FILTER_OPTION_LABELS, label) || label;
};

export function attributeFilterOptionByLabel(label: string): AttributeFilterOption {
  const value = retranslateAttributeOptionFilter(label);

  return {
    label,
    value
  };
}

export const toSortingBy = (
  sortingField: SearchAppQuerySortField,
  sortingDirection: SearchAppQuerySortDirection
): SortingBy => {
  switch (sortingField) {
    case "entity_id":
      return SortingBy.Newest;
    case "position":
      return SortingBy.Featured;
    case "price":
      return sortingDirection === "asc" ? SortingBy.LowestPrice : SortingBy.HighestPrice;
    default:
      return SortingBy.Newest;
  }
};
